export default __webpack_public_path__ + "static/media/info-page-about-us.2edc2140.png";